// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"ul-z","mainContent":"vl-z","activeSidebar":"wl-z"};